import { useState } from 'react';

import { Box, Button, Dialog, Text, VisuallyHidden } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { ImpersonationLink } from '../../components/Household/ImpersonationLink';
import { MessageCtaLink, MessageCtaModal } from '../../graphql/schema';

const CTADialog = ({ cta }: { cta: MessageCtaModal }) => {
  const [isOpen, setOpen] = useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setOpen(true);
  };

  return (
    <Dialog overlay="default" open={isOpen} onOpenChange={setOpen}>
      <VisuallyHidden>
        <Dialog.Title>{cta.content}</Dialog.Title>
      </VisuallyHidden>{' '}
      <Dialog.Trigger asChild={true} onClick={handleClick}>
        <Button variant="textPrimary" css={{ color: 'text', textDecoration: 'underline' }}>
          <Text variant="text100">{cta.text}</Text>
        </Button>
      </Dialog.Trigger>
      <Dialog.Content
        css={{
          p: 'space.400',
          overflowX: 'scroll',
        }}
        size="large"
      >
        <Dialog.Description asChild={true}>
          <Text variant="text100" dangerouslySetInnerHTML={{ __html: cta.content }} />
        </Dialog.Description>
        <Box css={{ display: 'flex', mt: 'space.400' }}>
          <Dialog.Close asChild={true}>
            <Button variant="solidSecondary">Close</Button>
          </Dialog.Close>
        </Box>
      </Dialog.Content>
    </Dialog>
  );
};

const CTALink: React.FC<{
  cta: MessageCtaLink;
}> = ({ cta }) => {
  if (cta.impersonationLink) {
    return (
      <>
        {' '}
        <Box css={{ display: 'inline-flex' }}>
          <ImpersonationLink variant="textPrimary" showModal={false} url={cta.url} label={cta.text} />
        </Box>
      </>
    );
  }
  return (
    <>
      {' '}
      <SambaAutoLink to={cta.url}>{cta.text}</SambaAutoLink>
    </>
  );
};

const MessageCta = ({ cta }: { cta: MessageCtaLink | MessageCtaModal }) => {
  if (cta.__typename === 'MessageCtaLink') {
    return <CTALink cta={cta} />;
  }
  if (cta.__typename === 'MessageCtaModal') {
    return <CTADialog cta={cta} />;
  }
  return null;
};

export default MessageCta;
